// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';

var Swipes = new Swiper('.swiper-container', {

    a11y: {
        enabled: true
    },
    centeredSlides: false,
    breakpointBase: 'window',
    slidesPerView: 2.5,
    // Responsive breakpoints
    breakpoints: {
        // when window width is >= 320px
        320: {
            slidesPerView: 1,
            spaceBetween: 20
        },
        // when window width is >= 480px
        400: {
            slidesPerView: 2,
            spaceBetween: 30
        },
        // when window width is >= 640px
        1200: {
            slidesPerView: 3,
            spaceBetween: 40
        }
    },
    spaceBetween: 20,
    slideClass:'swiper-slide',

    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
});